export default "__VITE_ASSET__aqeJ64hi__"